/**
 * azarai-blog.js
 * Azarai Jewel School — Article Interactions
 *
 * Functions:
 *   1. Accordion toggle (karat / item accordions)
 *   2. FAQ accordion toggle
 *   3. Mobile ToC dropdown
 *   4. Sidebar ToC active link on scroll
 *   5. Responsive layout switch (sidebar show/hide)
 *
 * Fully reusable in Ella 7.0 — no Ella internals referenced.
 * All selectors target .az-* custom classes only.
 */

(function () {
  'use strict';

  /* ── 1. ACCORDION (karat / item) ──────────────────────────────────────── */
  document.querySelectorAll('.az-accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var accordion = trigger.closest('.az-accordion');
      accordion.querySelectorAll('.az-accordion__trigger').forEach(function (t) {
        if (t !== trigger) {
          var b = t.nextElementSibling;
          var ic = t.querySelector('.az-accordion__icon');
          b.style.maxHeight = '0px';
          if (ic) ic.classList.add('is-closed');
        }
      });
      var body = trigger.nextElementSibling;
      var icon = trigger.querySelector('.az-accordion__icon');
      var isOpen = body.style.maxHeight && body.style.maxHeight !== '0px';
      body.style.maxHeight = isOpen ? '0px' : '600px';
      if (icon) { icon.classList.toggle('is-closed', isOpen); }
    });
  });


  /* ── 2. FAQ ACCORDION ─────────────────────────────────────────────────── */
  document.querySelectorAll('.az-faq__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var faq = trigger.closest('.az-faq');
      faq.querySelectorAll('.az-faq__trigger').forEach(function (t) {
        if (t !== trigger) {
          var b = t.nextElementSibling;
          var ic = t.querySelector('.az-faq__icon');
          b.style.maxHeight = '0px';
          if (ic) ic.classList.add('is-closed');
        }
      });
      var body = trigger.nextElementSibling;
      var icon = trigger.querySelector('.az-faq__icon');
      var isOpen = body.style.maxHeight && body.style.maxHeight !== '0px';
      body.style.maxHeight = isOpen ? '0px' : '400px';
      if (icon) { icon.classList.toggle('is-closed', isOpen); }
    });
  });


  /* ── 3. MOBILE TOC DROPDOWN ───────────────────────────────────────────── */
  var mobileTocTrigger = document.querySelector('.az-toc-mobile__trigger');
  var mobileTocDropdown = document.querySelector('.az-toc-mobile__dropdown');
  var mobileTocChevron = document.querySelector('.az-toc-mobile__chevron');

  if (mobileTocTrigger && mobileTocDropdown) {
    mobileTocTrigger.addEventListener('click', function () {
      var isOpen = mobileTocDropdown.classList.contains('is-open');
      mobileTocDropdown.classList.toggle('is-open', !isOpen);
      if (mobileTocChevron) {
        mobileTocChevron.classList.toggle('is-open', !isOpen);
      }
    });

    // Close dropdown when a link is tapped
    mobileTocDropdown.querySelectorAll('.az-toc-mobile__link').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileTocDropdown.classList.remove('is-open');
        if (mobileTocChevron) {
          mobileTocChevron.classList.remove('is-open');
        }
      });
    });
  }


  /* ── 4. SIDEBAR TOC ACTIVE LINK ON SCROLL ─────────────────────────────── */
  var tocLinks = document.querySelectorAll('.az-toc__link');

  if (tocLinks.length > 0) {
    var sectionIds = [];
    tocLinks.forEach(function (link) {
      var href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        sectionIds.push(href.slice(1));
      }
    });

    function updateActiveTocLink() {
      var scrollY = window.scrollY + 120;
      var activeId = sectionIds[0];

      sectionIds.forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.offsetTop <= scrollY) {
          activeId = id;
        }
      });

      tocLinks.forEach(function (link) {
        var href = link.getAttribute('href');
        if (href === '#' + activeId) {
          link.classList.add('is-active');
        } else {
          link.classList.remove('is-active');
        }
      });
    }

    window.addEventListener('scroll', updateActiveTocLink, { passive: true });
    updateActiveTocLink();
  }


  /* ── 5. RESPONSIVE LAYOUT SWITCH ─────────────────────────────────────── */
  var sidebar = document.querySelector('.az-sidebar');
  var mobileToc = document.querySelector('.az-toc-mobile');

  function handleResize() {
    var isMobile = window.innerWidth < 768;

    if (sidebar) {
      sidebar.style.display = isMobile ? 'none' : '';
    }

    if (mobileToc) {
      mobileToc.style.display = isMobile ? 'block' : 'none';
    }
  }

  window.addEventListener('resize', handleResize);
  handleResize();

})();